import { Component } from '@angular/core';

@Component({
  selector: 'app-risk-disclosure',
  templateUrl: './risk-disclosure.component.html',
  styleUrls: ['./risk-disclosure.component.css']
})
export class RiskDisclosureComponent {

}
